export default __webpack_public_path__ + "static/media/appDownloadIcon.56e75773.svg";